import { useEffect } from 'react';

export function useDocumentTitle(newTitle: string) {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = `${newTitle} | Cynet`;
    return () => {
      document.title = prevTitle;
    };
  });
}
